import { maskSensitiveData } from "@agentx/agentx-services";
export function getMaskedTaskData(task) {
    return Object.assign(Object.assign({}, task), { customerName: maskSensitiveData(task.customerName), displayAni: maskSensitiveData(task.displayAni), customerPhone: maskSensitiveData(task.customerPhone), customerEmail: maskSensitiveData(task.customerEmail), ani: maskSensitiveData(task.ani), dnis: maskSensitiveData(task.dnis), 
        // Only mask sourceNumber if not an outbound call
        origin: task.outboundType !== "outdial" ? maskSensitiveData(task.origin) : task.origin });
}
export function mapTaskDetailsToTask(taskDetail, maskData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
    const task = {
        id: taskDetail.id,
        isActive: taskDetail.isActive,
        status: taskDetail.status,
        // Channel information
        channelType: taskDetail.channelType,
        mediaType: taskDetail.channelType,
        mediaChannel: taskDetail.channelType,
        channelSubType: taskDetail.channelSubType,
        // Add missing required properties from Task interface
        createdTime: taskDetail.createdTime,
        endedTime: taskDetail.endedTime,
        origin: (_b = (_a = taskDetail.customer) === null || _a === void 0 ? void 0 : _a.phoneNumber) !== null && _b !== void 0 ? _b : "",
        destination: (_c = taskDetail.destination) !== null && _c !== void 0 ? _c : "",
        taskDirection: taskDetail.direction,
        isConsult: false,
        // Time information
        cstts: (_e = (_d = taskDetail.createdTime) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : "",
        cetts: (_g = (_f = taskDetail.endedTime) === null || _f === void 0 ? void 0 : _f.toString()) !== null && _g !== void 0 ? _g : "",
        customerName: (_j = (_h = taskDetail.customer) === null || _h === void 0 ? void 0 : _h.name) !== null && _j !== void 0 ? _j : "",
        ani: (_m = (((_k = taskDetail.customer) === null || _k === void 0 ? void 0 : _k.phoneNumber) || ((_l = taskDetail.customer) === null || _l === void 0 ? void 0 : _l.email))) !== null && _m !== void 0 ? _m : "",
        displayAni: (_q = (((_o = taskDetail.customer) === null || _o === void 0 ? void 0 : _o.phoneNumber) || ((_p = taskDetail.customer) === null || _p === void 0 ? void 0 : _p.email))) !== null && _q !== void 0 ? _q : "",
        // Additional required properties
        isHold: taskDetail.holdCount > 0,
        isConferencing: taskDetail.conferenceCount > 0,
        virtualTeamName: (_s = (_r = taskDetail.lastTeam) === null || _r === void 0 ? void 0 : _r.name) !== null && _s !== void 0 ? _s : "",
        state: taskDetail.status,
        ownerName: (_u = (_t = taskDetail.lastAgent) === null || _t === void 0 ? void 0 : _t.name) !== null && _u !== void 0 ? _u : "",
        agentName: (_w = (_v = taskDetail.lastAgent) === null || _v === void 0 ? void 0 : _v.name) !== null && _w !== void 0 ? _w : "",
        sid: taskDetail.id,
        // Other properties with default values if not available
        dnis: (_x = taskDetail.destination) !== null && _x !== void 0 ? _x : "",
        wrapupCodeName: (_y = taskDetail.lastWrapupCodeName) !== null && _y !== void 0 ? _y : "",
        wrapupCodeId: (_z = taskDetail.lastWrapUpCodeId) !== null && _z !== void 0 ? _z : "",
        // Duration
        talkDuration: (_0 = taskDetail.connectedDuration) !== null && _0 !== void 0 ? _0 : 0,
        queueDuration: (_1 = taskDetail.queueDuration) !== null && _1 !== void 0 ? _1 : 0,
        wrapupDuration: (_2 = taskDetail.wrapupDuration) !== null && _2 !== void 0 ? _2 : 0,
        totalDuration: (_3 = taskDetail.totalDuration) !== null && _3 !== void 0 ? _3 : 0,
        subject: taskDetail.channelType === "email"
            ? ((_6 = (_5 = (_4 = taskDetail.channelMetaData) === null || _4 === void 0 ? void 0 : _4.email) === null || _5 === void 0 ? void 0 : _5.subject) !== null && _6 !== void 0 ? _6 : "")
            : ((_9 = (_8 = (_7 = taskDetail.channelMetaData) === null || _7 === void 0 ? void 0 : _7.chat) === null || _8 === void 0 ? void 0 : _8.chatReason) !== null && _9 !== void 0 ? _9 : ""),
        outboundType: taskDetail.isOutdial ? "outdial" : undefined,
        entrypointId: (_11 = (_10 = taskDetail.lastEntryPoint) === null || _10 === void 0 ? void 0 : _10.id) !== null && _11 !== void 0 ? _11 : "",
        entrypointName: (_13 = (_12 = taskDetail.lastEntryPoint) === null || _12 === void 0 ? void 0 : _12.name) !== null && _13 !== void 0 ? _13 : "",
        contactReason: (_16 = (_15 = (_14 = taskDetail.channelMetaData) === null || _14 === void 0 ? void 0 : _14.chat) === null || _15 === void 0 ? void 0 : _15.chatReason) !== null && _16 !== void 0 ? _16 : "",
        customerPhone: (_18 = (_17 = taskDetail.customer) === null || _17 === void 0 ? void 0 : _17.phoneNumber) !== null && _18 !== void 0 ? _18 : "",
        customerEmail: (_20 = (_19 = taskDetail.customer) === null || _19 === void 0 ? void 0 : _19.email) !== null && _20 !== void 0 ? _20 : "",
        queueId: (_22 = (_21 = taskDetail.lastQueue) === null || _21 === void 0 ? void 0 : _21.id) !== null && _22 !== void 0 ? _22 : "",
        queueName: (_24 = (_23 = taskDetail.lastQueue) === null || _23 === void 0 ? void 0 : _23.name) !== null && _24 !== void 0 ? _24 : "",
        csatScore: (_25 = taskDetail.csatScore) !== null && _25 !== void 0 ? _25 : 0,
        autoCsat: (_26 = taskDetail.autoCsat) !== null && _26 !== void 0 ? _26 : "",
        requiredSkills: (_27 = taskDetail.requiredSkills) !== null && _27 !== void 0 ? _27 : "",
        isOutdial: (_28 = taskDetail.isOutdial) !== null && _28 !== void 0 ? _28 : false,
        isCallback: false,
        isCallbackTask: false,
        priority: 0,
        transcript: undefined,
        outboundTranscript: undefined,
        terminationType: undefined,
        appUser: undefined,
        uiProcessing: false
    };
    if (maskData) {
        return getMaskedTaskData(task);
    }
    return task;
}
//Move to task service utils
function isInteractionOnHold(interaction) {
    if (!interaction.media) {
        return false;
    }
    return Object.values(interaction.media).some((media) => media.isHold);
}
export function mapContactToTask(contact, maskData, uiProcessing) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const interaction = contact.data.interaction;
    const callProcessingDetails = interaction.callProcessingDetails;
    const task = {
        id: contact.data.interactionId,
        isActive: interaction.state === "active",
        status: interaction.state,
        // Channel information
        channelType: interaction.mediaType,
        channelSubType: "",
        mediaType: interaction.mediaType,
        mediaChannel: interaction.mediaChannel,
        // Time information
        createdTime: (_a = interaction.createdTimestamp) !== null && _a !== void 0 ? _a : Date.now(),
        endedTime: 0,
        cstts: (_c = (_b = interaction.createdTimestamp) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "",
        cetts: "",
        // Customer information
        origin: (_d = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.ani) !== null && _d !== void 0 ? _d : "",
        destination: (_e = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.dnis) !== null && _e !== void 0 ? _e : "",
        customerName: (_f = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.customerName) !== null && _f !== void 0 ? _f : "",
        customerPhone: (_g = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.ani) !== null && _g !== void 0 ? _g : "",
        customerEmail: (_h = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.fromAddress) !== null && _h !== void 0 ? _h : "",
        ani: (_j = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.ani) !== null && _j !== void 0 ? _j : "",
        displayAni: (_k = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.displayAni) !== null && _k !== void 0 ? _k : "",
        dnis: (_l = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.dnis) !== null && _l !== void 0 ? _l : "",
        // Direction information
        taskDirection: (_p = (_o = (_m = interaction.contactDirection) === null || _m === void 0 ? void 0 : _m.type) === null || _o === void 0 ? void 0 : _o.toLowerCase()) !== null && _p !== void 0 ? _p : "",
        // Team and routing information
        virtualTeamName: (_q = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.virtualTeamName) !== null && _q !== void 0 ? _q : "",
        entrypointId: (_r = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.EP_ID) !== null && _r !== void 0 ? _r : "",
        entrypointName: "",
        queueId: (_s = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.QueueId) !== null && _s !== void 0 ? _s : "",
        queueName: "",
        // Agent information
        ownerName: "",
        agentName: "",
        // Subject and reason
        contactReason: (_t = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.reason) !== null && _t !== void 0 ? _t : "",
        subject: (_u = callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.reason) !== null && _u !== void 0 ? _u : "",
        // Status information
        state: interaction.state,
        sid: contact.data.interactionId,
        // Call details
        isConsult: contact.data.isConsulted || false,
        isConferencing: contact.data.isConferencing || false,
        isHold: isInteractionOnHold(interaction),
        isOutdial: interaction.outboundType ? true : false,
        outboundType: interaction.outboundType,
        // Durations
        talkDuration: 0,
        queueDuration: 0,
        wrapupDuration: 0,
        totalDuration: 0,
        // Wrapup information
        wrapupCodeId: "",
        wrapupCodeName: "",
        // Other required fields
        requiredSkills: "",
        priority: parseInt((callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.priority) || "0"),
        csatScore: 0,
        autoCsat: "",
        transcript: undefined,
        outboundTranscript: undefined,
        terminationType: undefined,
        // App user for social channels
        appUser: callProcessingDetails === null || callProcessingDetails === void 0 ? void 0 : callProcessingDetails.appUser,
        // Callback information
        isCallback: interaction.outboundType === "callback",
        isCallbackTask: interaction.outboundType === "callback",
        contactAssignmentType: contact.data.contactAssignmentType,
        uiProcessing
    };
    if (maskData) {
        return getMaskedTaskData(task);
    }
    return task;
}
